import {
    convertChartLabelDate,
    dateFormatKey,
    dateFormatRich,
} from "../../lens-insights/converters/convertChartLabelDate";
import { safeDivide, summarizeMetricsArray } from "../../lens-insights/math";
import { type InsightsMetrics, type StatsItem, createDefaultInsightsMetrics } from "../../lens-insights/models";
import { formatNullableNumber } from "../../lens-stats/formatters/formatNumbers";
import { type LensScoreDailyFieldsFragment, type LensScoreWindowFieldsFragment } from "../api/queries";

export const lensPlusDailyMetrics = (
    window: (LensScoreWindowFieldsFragment & LensScoreDailyFieldsFragment) | null,
    metric: "subscriberActionsUu" | "subscribeCount" | "lensScore",
): InsightsMetrics<StatsItem> => {
    const stats = [...(window?.dailyBuckets ?? [])]
        .sort((firstBucket, secondBucket) => firstBucket.date.localeCompare(secondBucket.date))
        .map(({ date, metrics }) => ({
            key: convertChartLabelDate(new Date(date), dateFormatKey),
            date: convertChartLabelDate(new Date(date), dateFormatRich),
            value: metrics[metric],
        }));
    return {
        ...createDefaultInsightsMetrics<StatsItem>(),
        stats,
        totalValue: window?.totals?.[metric] ?? 0,
        totalValueFormatted: formatNullableNumber(window?.totals?.[metric]),
        averageValue: safeDivide(summarizeMetricsArray(stats), stats.length),
    };
};
